<template>
  <div
    class="c-navbar"
    :class="{
      'c-navbar--overlay': overlay,
      'c-navbar--android': os === 'android',
      'c-navbar--centered': isCentered,
      'c-navbar--extended': isExtended
    }"
  >
    <a href="#" class="c-navbar__back" @click="goBack" v-if="hasBackButton">
      <o-icon icon="back-ios" v-if="os !== 'android'" />
      <o-icon icon="back-android" v-if="os === 'android'" />
    </a>
    <h1 class="c-navbar__title">{{ title }}</h1>
    <div class="c-navbar__right">
      <slot name="right">
        <o-icon icon="support" v-if="$store.state.showSupportButton" />
        <router-link
          v-if="hasCloseButton"
          :to="closeLink"
          class="c-navbar__close"
        >
          <o-icon icon="close" />
        </router-link>
      </slot>
    </div>
    <div class="c-navbar__logo" v-if="logo">
      <o-icon :icon="logo" :keep-colors="true" />
    </div>
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'ONavBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    overlay: {
      type: Boolean,
      default: false
    },
    hasCloseButton: {
      type: Boolean,
      default: false
    },
    hasBackButton: {
      type: Boolean,
      default: false
    },
    closeLink: {
      type: String,
      default: '/'
    },
    isCentered: {
      type: Boolean,
      default: false
    },
    isExtended: {
      type: Boolean,
      default: false
    },
    logo: {
      type: String,
      default: null
    },
    backgroundImage: {
      type: String,
      default: null
    }
  },
  computed: {
    os() {
      return this.$store.getters.os
    }
  },
  methods: {
    goBack(e) {
      e.preventDefault()
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.c-navbar {
  align-items: flex-start;
  background-color: $primary-color;
  background-color: var(--primary-color);
  color: #fff;
  display: flex;
  font-size: 1.7rem;
  font-weight: 600;
  letter-spacing: -0.033rem;
  line-height: 2.4rem;
  min-height: 4.4rem;
  padding: 1rem;
  position: relative;
  z-index: 10;
}

.c-navbar--overlay {
  background: rgba(#000, 0.05);
}

.c-navbar__back {
  display: block;
  margin-right: 3.2rem;
  opacity: 0.6;

  .c-icon {
    display: block;
  }
}

.c-navbar:not(.c-navbar--android) .c-navbar__title,
.c-navbar--centered .c-navbar__title {
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}

.c-navbar--android {
  font-size: 2rem;
  min-height: 5.6rem;
  padding: 1.6rem;
}

.c-navbar--extended {
  min-height: 7.2rem;
}

.c-navbar--android.c-navbar--extended {
  min-height: 8.4rem;
}

.c-navbar__right {
  align-items: center;
  display: flex;
  margin-left: auto;

  & > * {
    opacity: 0.6;
  }

  & > *:not(:last-child) {
    margin-right: 16px;
  }
}

.c-navbar__close {
  font-weight: normal;

  .c-icon {
    display: block;
  }
}

.c-navbar__logo {
  background: #fff;
  border-radius: 50%;
  bottom: -2.8rem;
  box-shadow: $box-shadow-list;
  display: flex;
  height: 5.6rem;
  left: calc(50% - 2.8rem);
  position: absolute;
  width: 5.6rem;

  .c-icon {
    flex: none;
    height: 3.2rem;
    margin: auto;
    width: 3.2rem;
  }
}
</style>
